// The three ways to play, and the two questions the rest of the app asks about them:
// does the device that created the lobby play on it, and does the table have sides?
//
// A party is the original game: a TV shows the board and the phones are hands. The
// other two are phone-only — there is no screen to gather round, so the creator takes
// a seat and the lobby has a fixed number of them.
export const PARTY_MODE = "party";
export const DUEL_MODE = "1v1";
export const TEAM_MODE = "2v2";

export const GAME_MODES = [
  {
    id: PARTY_MODE,
    label: "Partyläge",
    blurb: "TV:n visar bordet, alla andra spelar från mobilen.",
    seats: 0,
    phoneOnly: false,
    teamed: false,
  },
  {
    id: DUEL_MODE,
    label: "1 mot 1",
    blurb: "Två mobiler, ingen TV. Kortast match.",
    seats: 2,
    phoneOnly: true,
    teamed: false,
  },
  {
    id: TEAM_MODE,
    label: "2 mot 2",
    blurb: "Fyra mobiler, ingen TV. Du kan inte träffa din partner.",
    seats: 4,
    phoneOnly: true,
    teamed: true,
  },
];

function modeInfo(mode) {
  return GAME_MODES.find((entry) => entry.id === mode) || GAME_MODES[0];
}

// Which rules the match runs under is the most load-bearing field in the synced blob,
// so an unknown value falls back to the mode with no special rules rather than being
// trusted. Party is the fallback and is stored as undefined, because a blob written
// before modes existed has no field at all and must keep playing exactly as it did.
export function normalizeMode(value) {
  return GAME_MODES.some((entry) => entry.id === value && entry.id !== PARTY_MODE) ? value : PARTY_MODE;
}

// No TV: the creating device is one of the players, so it keeps its seat through
// normalizeGameState and gets the hand rather than the board.
export function isPhoneMode(state) {
  return modeInfo(state?.mode).phoneOnly;
}

// Sides, and therefore teammates you may not hit. Only the 2 mot 2 has them.
export function isTeamMode(state) {
  return modeInfo(state?.mode).teamed;
}

// How many seats the lobby holds. Zero means "as many as turn up", which is the party.
export function seatsFor(mode) {
  return modeInfo(mode).seats;
}
